// extracted by mini-css-extract-plugin
export default {"buttonText":"Button_buttonText__lntwb","enabled":"Button_enabled__T-I30","disabled":"Button_disabled__ibF0o"};